export default (props) => (
    /**
     * Icone de Norte.
     */
    <svg 
        width="18,5"
        height="26" 
        viewBox="0 0 11 15" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
          d="M0.982378 14.1072L5.84485 0.309845C5.8803 0.209229 6.07237 0.209214 6.10785 0.309824L10.9727 14.1024C11.0079 14.2023 10.843 14.2726 10.745 14.1995L6.03891 10.694C6.00705 10.6703 5.95533 10.6703 5.92347 10.694L1.21008 14.2042C1.11205 14.2772 0.947203 14.207 0.982378 14.1072Z" 
          fill="black"
        />
        <path 
          d="M5.87795 10.301V1.40833C5.87795 1.38458 5.83245 1.38027 5.82444 1.40325L1.6288 13.4406C1.62184 13.4606 1.65488 13.4745 1.67443 13.4599L5.87006 10.3153C5.87511 10.3115 5.87795 10.3064 5.87795 10.301Z" 
          fill="white"
        />
    </svg>
  );